import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Scrollbar } from 'swiper';
import EcoImg from 'eco-design/base/eco-img';
import EcoDialogVideo from 'eco-design/elements/eco-dialog-video';

import styles from './index.module.scss';
import getLocal from '@/app/utils/getLocal';
import { useLang } from '@/i18n';
import PlayIcon from './PlayIcon';
import { useState } from 'react';
import { useScrollAnimation, cn } from 'elem/compPage/battery-backup-for-home/scroll-animation-v2';

export default function Recommended() {
    const { t } = useLang('powerbackup');
    const { locale } = getLocal();
    const [source, setSource] = useState('');

    const lists = [
        {
            title: t('secL_list1_title'),
            desc: t('secL_list1_desc'),
            pc: 'https://websiteoss.ecoflow.com/figma-uploads/1769500735903-igt35a-compressed-Frame%202094655028.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1747290953175/1-h5.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1747290953175/1-h5.jpg',
            video: 'https://www.youtube.com/embed/JcKq6neGxXk',
        },
        {
            title: t('secL_list2_title'),
            desc: t('secL_list2_desc'),
            pc: 'https://websiteoss.ecoflow.com/figma-uploads/1769500762442-8pede9-compressed-Frame%202094655029.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1747290953525/2-h5.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1747290953525/2-h5.jpg',
            video: 'https://www.youtube.com/embed/3aTQSXtpHmU',
        },
        {
            title: t('secL_list3_title'),
            desc: t('secL_list3_desc'),
            pc: 'https://websiteoss.ecoflow.com/figma-uploads/1769500773200-fnyhkm-compressed-Frame%202094655031.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1747290954301/3-h5.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1747290954301/3-h5.jpg',
            video: 'https://www.youtube.com/embed/WE9Ct6Pz8nw',
        },
        {
            title: t('secL_list4_title'),
            desc: t('secL_list4_desc'),
            pc: 'https://websiteoss.ecoflow.com/figma-uploads/1769500782805-dfzhus-compressed-Frame%202094655030.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1747290953897/4-h5.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1747290953897/4-h5.jpg',
            video: 'https://www.youtube.com/embed/hMVkwZ5ZUCI',
        },
    ];

    const { ref, isVisible } = useScrollAnimation({
        threshold: 0.1,
        rootMargin: '-20% 0px',
    });

    return (
        <div ref={ref} className={`${styles.Recommended} GtmModuleData-section`}>
            <div className="pb-layout">
                <div className={cn(isVisible, 'power-backup-title fade-up')}>{t('secL_title')}</div>
                <Swiper
                    className="swiper-box"
                    effect="fade"
                    modules={[Scrollbar, Navigation]}
                    spaceBetween={20}
                    slidesPerView={'auto'}
                    initialSlide={0}
                    scrollbar={{
                        hide: false,
                        draggable: true,
                        dragSize: 'auto',
                        snapOnRelease: true,
                    }}
                    navigation={{
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                    }}
                >
                    {lists?.map((card, k: number) => (
                        <SwiperSlide
                            className={cn(isVisible, 'swiper-item fade-up')}
                            style={{ '--animate-delay': `${(k + 2) * 0.15}s` } as React.CSSProperties}
                            key={k}
                        >
                            <div className="recommended-img-wrapper">
                                <EcoImg pc={card?.pc} />
                                <PlayIcon className="play-icon" onClick={() => setSource(card.video)} />
                            </div>
                            <div className="bottom-wrapper">
                                <div className="bottom-title">{card.title}</div>
                                <div className="bottom-desc">{card.desc}</div>
                            </div>
                        </SwiperSlide>
                    ))}
                    <div className="swiper-button-prev" />
                    <div className="swiper-button-next" />
                </Swiper>
                {!!source && <EcoDialogVideo open={!!source} src={source} callback={() => setSource('')} />}
            </div>
        </div>
    );
}
